module.exports = __webpack_public_path__ + "static/img/areaB_02.5f30c07.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/areaB_02.png
// module id = 1263
// module chunks = 1